import React from 'react';
import { womenCalculators_Fr } from '../ConstantsWomenCalculator';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices pour femmes: cycle, ovulation et grossesse';
const DESCRIPTION = 'Suivez votre cycle menstruel, vos fenetres d ovulation, la grossesse et la date d accouchement avec des calculatrices en francais concues pour un usage simple et rapide.';
const KEYWORDS = 'calculatrice cycle menstruel, calcul ovulation, calcul grossesse, date accouchement, conception';
const OG_URL = 'https://do-calculate.com/fr/women-calculators/';

function WomenCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Des outils pratiques pour mieux suivre les grandes etapes du cycle et de la grossesse.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {womenCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default WomenCalculatorsList;
